<h1 mat-dialog-title>
  Seleccionar instituciones</h1>
<div
  mat-dialog-content
  style="padding-bottom: 0"
>
  <p class="generic-modal-body">
    Seleccione las instituciones que quiere agregar:
  </p>
  <ng-container>
    <input
      (keyup)="applyFilter($event)"
      placeholder="Filtrar instituciones"
      #input
      cFormControl
      type="text"
      class="mb-3"
    />
  </ng-container>
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
  >
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th
        mat-header-cell
        *matHeaderCellDef
      >
        <div class="form-check">
          <input
            (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            [ariaLabel]="checkboxLabel()"
            class="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckDefault"
          />
        </div>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
      >
        <input
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
          [ariaLabel]="checkboxLabel(row)"
          class="form-check-input"
          type="checkbox"
          value=""
          id="flexCheckDefault"
        />
      </td>
    </ng-container>
    <ng-container matColumnDef="id">
      <th
        mat-header-cell
        *matHeaderCellDef
      >id</th>
      <td
        mat-cell
        *matCellDef="let element"
      >{{ element.id }}</td>
    </ng-container>
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef
      >Name</th>
      <td
        mat-cell
        *matCellDef="let element"
      >{{ element.name }}</td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="selection.toggle(row)"
    ></tr>

    <tr
      class="mat-row"
      *matNoDataRow
    >
      <td
        class="mat-cell"
        colspan="4"
      >
        No data matching the filter "{{ input.value }}"
      </td>
    </tr>
  </table>

  <mat-paginator
    [pageSizeOptions]="[5, 10, 25, 100]"
    aria-label="Select page of users"
  ></mat-paginator>
</div>
<div
  mat-dialog-actions
  class="generic-modal-actions"
>
  <button
    cButton
    variant="ghost"
    color="danger"
    mat-dialog-close="cancel"
  >
    Cancelar
  </button>
  <button
    cButton
    variant="ghost"
    color="primary"
    mat-dialog-close="send"
    cdkFocusInitial
    (click)="onSave()"
  >
    Guardar
  </button>
</div>
